import BlockFailedLogins from "./BlockFailedLogins";
import LoginWith2FA from "./LoginWith2FA";
import PasswordlessLogin from "./PasswordlessLogin";
import PasswordRequirements from "./PasswordRequirements";

const policiesComponents = {
  BlockFailedLogins,
  LoginWith2FA,
  PasswordlessLogin,
  PasswordRequirements,
}

export default policiesComponents